import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { UsePostResult } from "@/src/CustomHooks/usePostResult";
import { API_ENDPOINTS } from "@/src/utilities";

interface SubscribeInputProps {
  variant?: "light" | "dark";
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function SubscribeInput({ variant = "dark" }: SubscribeInputProps) {
  const { loading, postData } = UsePostResult<{ message: string }>();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const isValidEmail = EMAIL_REGEX.test(email);

  const handleSubmit = () => {
    if (!email) {
      setError("Email is required");
      return;
    }
    if (!isValidEmail) {
      setError("Please enter a valid email address");
      return;
    }
    setError("");
    postData(
      API_ENDPOINTS.SUBSCRIBE_NEWSLETTERS,
      {
        data: {
          email: email,
        },
      },
      {},
      "Subscribed successfully"
    );
    setEmail("");
  };

  const inputClassName =
    variant === "light"
      ? "bg-white border-white/20 text-black placeholder:text-muted-foreground flex-1"
      : "bg-white/10 border-white/20 text-white placeholder:text-white/60 flex-1";

  const buttonClassName =
    variant === "light"
      ? "bg-white text-primary hover:bg-white/90"
      : "bg-white text-theme-secondary hover:bg-white/90";

  return (
    <div className="flex flex-col gap-2 w-full max-w-md mx-auto">
      <Input
        type="email"
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
          if (error) setError("");
        }}
        placeholder="Enter your email"
        className={`${inputClassName} w-full py-2.5`}
      />
      <Button
        variant={variant === "light" ? "default" : "secondary"}
        className={`${buttonClassName} w-full`}
        onClick={handleSubmit}
        disabled={!isValidEmail}
        isLoading={loading}
      >
        Subscribe
        <ArrowRight className="ml-2 h-4 w-4" />
      </Button>
      {error && (
        <p className={`text-xs text-center ${variant === "light" ? "text-red-600" : "text-red-400"}`}>
          {error}
        </p>
      )}
    </div>
  );
}

export default SubscribeInput;
